import axios from 'axios';
import { getIssuer } from '~/helpers/getIssuer';

const axiosInstance = axios.create();

function logout() {
  axiosInstance.defaults.headers.common.Authorization = '';
  sessionStorage.removeItem('token');
  window.location.assign('#/login');
  window.location.reload();
}

// Add a request interceptor
axiosInstance.interceptors.request.use(config => {
  // eslint-disable-next-line no-param-reassign
  config.headers.common.issuer = getIssuer();

  const modifiedConfig = {
    ...config,

    headers: {
      'X-XSS-Protection': '1',
      'x-frame-option': 'DENY',
      'X-Content-Type-Options': 'nosniff',

      ...config.headers,
    },
  };
  return modifiedConfig;
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const { response } = error;

    // -13: Invalid authorization token
    if (response?.data?.messages?.find(item => item.code === '-13')) {
      logout();
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
